import React from "react";
import CartSection from "../components/CartSection";
import BreadcrumbTwo from "../components/BreadcrumbTwo";

const CartPage = () => {
  return (
    <>
      <BreadcrumbTwo title="Cart" />
      <CartSection />
    </>
  );
};

export default CartPage;